import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=f8f0fb84&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=f8f0fb84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f0fb84",
  null
  
)

export default component.exports